import { render, staticRenderFns } from "./PageHeaderBlackFriday.vue?vue&type=template&id=96fed024&"
import script from "./PageHeaderBlackFriday.vue?vue&type=script&lang=js&"
export * from "./PageHeaderBlackFriday.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/pages/black-friday.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports